import { render, staticRenderFns } from "./CustomBuilds.vue?vue&type=template&id=d34bf87a&scoped=true&"
import script from "./CustomBuilds.vue?vue&type=script&lang=js&"
export * from "./CustomBuilds.vue?vue&type=script&lang=js&"
import style0 from "./CustomBuilds.vue?vue&type=style&index=0&id=d34bf87a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34bf87a",
  null
  
)

export default component.exports